import { cn } from './cn';
import { SparkleGlyph } from './Sparkle';
import { BRAND } from '@/contracts/brand';

/**
 * Wordmark. The name is read as one word by screen readers ("examine"),
 * while sighted users see the bracketed magic (x).
 * Brand strings stay configurable (spec §21 / F31).
 */
export function Logo({
  className,
  size = 'md',
}: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  const scale = { sm: 'text-[22px]', md: 'text-[28px]', lg: 'text-[40px] sm:text-[54px]' }[size];
  const [before, mark, after] = BRAND.nameParts;

  return (
    <span
      className={cn('inline-flex select-none items-baseline font-display font-semibold', scale, className)}
      aria-label={BRAND.spokenName}
      role="img"
    >
      <span aria-hidden className="text-ink">
        {before}
      </span>
      <span aria-hidden className="relative mx-[0.06em] inline-flex items-center">
        <span className="text-ink-faint">(</span>
        <span className="u-gradient-text px-[0.02em]">{mark}</span>
        <span className="text-ink-faint">)</span>
        <SparkleGlyph
          className="absolute -right-[0.34em] -top-[0.42em] h-[0.42em] w-[0.42em] animate-twinkle text-magic"
        />
      </span>
      <span aria-hidden className="text-ink">
        {after}
      </span>
    </span>
  );
}
